import { TilesType } from 'types/src/types';
import { TooltipComponent } from '../layout';

type Props = {
  onClick: (type: TilesType) => void;
};

export const AddNoteIcon = ({ onClick }: Props) => {
  return (
    <TooltipComponent text="Add Note" className="bg-black text-white w-fit">
      <button
        className="border-1 border-black/5 bg-white rounded-[8px] overflow-hidden size-8 custom-shadow hover:bg-bg-gray hover:border-transparent transition-all ease-in-out duration-300"
        onClick={() => onClick('add-note')}
      >
        <div className="h-2 w-full bg-[#FFDD55]" />
        <div className="flex flex-col gap-0.5 p-1">
          <div className="h-[3px] w-5.5 bg-bg-gray rounded-sm" />
          <div className="h-[3px] w-3 bg-bg-gray rounded-sm" />
          <div className="h-[3px] w-5 bg-bg-gray rounded-sm" />
        </div>
      </button>
    </TooltipComponent>
  );
};
